<div class="header flex-row space-between items-center">
    <div class="label-text">{{ headingTitle }}</div>
    <div class="desc">{{ headingTitleSubtext }}</div>
</div>

<div [hidden]="!scrollMe">
    <div #scrollMe class="notes-container">
        <div class="notes-item" *ngFor="let note of agencyNotes">
            <div data-qa-id="an_offer_note_header" class="notes-item-header flex-row space-between items-center">
                <ng-container *ngIf="!shouldDisplayCategoryChips(note)">
                    <div class="user">{{ note.fullName }} ({{ note.description }}) {{ note.title ? '- ' + note.title : '' }}</div>
                </ng-container>
                <ng-container *ngIf="shouldDisplayCategoryChips(note)">
                    <div class="user flex-row-wrap items-baseline gap-8">{{ note.fullName }} ({{ note.description }})<ng-container *ngIf="note.category"><mat-chip data-qa-id="an_offer_note_category_chip" class="note-category-chip">{{note.category}}</mat-chip></ng-container></div>
                </ng-container>
                <div class="timestamp">{{ note.createdDate | date: 'MM/dd/yyyy hh:mm:ss a'}}</div>
            </div>
            <ng-container *ngIf="shouldDisplayTitleOnNewLine(note)">
                <div data-qa-id="an_offer_note_title_new_line" class="notes-title">
                    {{note.title}}
                </div>
            </ng-container>
            <div data-qa-id="an_offer_note_body" class="notes-body">
                <p class="note" [innerHtml]="note.note"></p>
            </div>
        </div>
    </div>
</div>

<div class="note-input">
    <ng-content select="[noteInput]"></ng-content>
</div>
